var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6197 16.3188V13.763C5.61968 13.1154 6.14631 12.5892 6.79862 12.5852H9.19376C9.84898 12.5852 10.3801 13.1125 10.3801 13.763V16.3113C10.3801 16.8731 10.8366 17.3296 11.4024 17.3337H13.0364C13.7996 17.3356 14.5322 17.036 15.0726 16.5009C15.6129 15.9658 15.9166 15.2393 15.9166 14.4816V7.22186C15.9166 6.60982 15.6433 6.02925 15.1704 5.63658L9.61907 1.22888C8.64868 0.457928 7.26273 0.482832 6.32108 1.28815L0.889096 5.63658C0.393869 6.01768 0.0978789 6.59996 0.083252 7.22186V14.4742C0.083252 16.0534 1.37274 17.3337 2.9634 17.3337H4.56016C4.83256 17.3356 5.09449 17.2296 5.28781 17.039C5.48113 16.8485 5.58986 16.5892 5.58985 16.3188H5.6197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarHome);
export default __webpack_public_path__ + "static/media/navbar-home.17b142ef2733bf6f79b32ead6ac321b3.svg";
export { ForwardRef as ReactComponent };